// extracted by mini-css-extract-plugin
export var alignCenter = "_b9-d";
export var bannerShown = "_b9-6";
export var buttonContent = "_b9-0";
export var cardList = "_b9-1";
export var centerContent = "_b9-2";
export var chevron = "_b9-3";
export var closePanelButton = "_b9-k";
export var conversationContextContainer = "_b9-l";
export var conversationDetailContainer = "_b9-4";
export var detailWrapper = "_b9-7";
export var dropdownButton = "_b9-e";
export var dropdownTitle = "_b9-9";
export var fullHeight = "_b9-5";
export var hidden = "_b9-a";
export var icon = "_b9-b";
export var mergeSuggestionWrapper = "_b9-m";
export var panel = "_b9-i";
export var portalButtonsWrapper = "_b9-c";
export var right = "_b9-j";
export var tableSummaryContainer = "_b9-8";
export var tableSummaryHeader = "_b9-g";
export var threeDotsButton = "_b9-f";
export var wide = "_b9-h";